import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { css } from "styled-components";

filterStyles.appliedFilterTag = {
    css: css`
        align-items: center;
    `,
};
